import { type ReactNode } from 'react'

import { Label } from '@/components/ui/label'

/**
 * Labelled form row: label (+ optional required `*`), the control, and an
 * optional hint / error message. Consolidates the `Labeled` helper that was
 * defined near-identically in the Landlords/Users/Flats forms.
 */
interface LabeledProps {
  label: string
  required?: boolean
  error?: string
  hint?: string
  className?: string
  children: ReactNode
}

export function Labeled({
  label,
  required,
  error,
  hint,
  className,
  children
}: LabeledProps) {
  return (
    <div className={className}>
      <Label className="mb-1.5 block">
        {label}
        {required && <span className="ml-0.5 text-destructive">*</span>}
      </Label>
      {children}
      {hint && !error && (
        <p className="mt-1.5 text-xs text-muted-foreground">{hint}</p>
      )}
      {error && (
        <p className="mt-1.5 text-sm font-medium text-destructive">{error}</p>
      )}
    </div>
  )
}
